<script>
import { JSEncrypt } from 'jsencrypt'

export default {
  name: 'UtilsMixin',
  methods: {
    isAppMode(modes = []) {
      return modes.includes(this.$appMode)
    },

    async checkCenterSelected() {
      const selectedCenter = await this.getUserSelectedCenter()

      if (this.$validate.DataValid(selectedCenter) && selectedCenter > -1) return true

      this.$store.dispatch('showAlert', { message: 'message.accountNoCenter', isError: true })
      return false
    },

    // -------------- Order Related
    globalParseOrderData(el, simplifyRepeatOrderItem = false, showRepeatOrderItemCount = false) {
      let total_price_text = `HK$${this.$formatter.separator(this.$formatter.formatMoney(el.real_total))}`
      if (el.status === 'void') {
        total_price_text = this.$t('orderCancelled')
      } else if (el.status === 'debit') {
        total_price_text = `HK$${this.$formatter.separator(
          this.$formatter.formatMoney(el.real_total - el.debit_amount),
        )}`
        total_price_text += this.$t('refundedRemark', { refund: el.debit_amount })
      }

      let orderItemsText = el.order_items.join(',\n ')
      if (simplifyRepeatOrderItem) {
        const orderItemCount = []
        for (let i = 0; i < el.order_items.length; i++) {
          const index = orderItemCount.findIndex(obj => {
            return obj.name === el.order_items[i]
          })

          if (index !== -1) {
            orderItemCount[index].count++
          } else {
            orderItemCount.push({ name: el.order_items[i], count: 1 })
          }
        }

        if (showRepeatOrderItemCount) {
          orderItemsText = orderItemCount
            .map(obj => {
              return obj.count > 1 ? `${obj.name} x ${obj.count}` : obj.name
            })
            .join(',\n ')
        } else {
          orderItemsText = orderItemCount
            .map(obj => {
              return obj.name
            })
            .join(',\n ')
        }
      }

      let payment_records = []
      if (el.payment_records.length) {
        payment_records = el.payment_records.map(invoice => {
          return {
            ...invoice,
            order_id: `${this.$formatter.generateOrderId(el)}-${invoice.index}`,
            create_date: invoice.date.substring(0, 10),
            customer_name: el.customer_name,
            user_code: el.user_code,
            order_type: el.order_type,
            month: el.month,
            order_items: orderItemsText,
            qty: el.qty,
            total_price: `HK$${this.$formatter.separator(this.$formatter.formatMoney(el.real_total))}`,
            paid_total: `HK$${this.$formatter.separator(this.$formatter.formatMoney(invoice.amount))}`,
            balance_price: `HK$${this.$formatter.separator(this.$formatter.formatMoney(el.balance))}`,
            remark: invoice.remark,
            status: el.status,
          }
        })
      }
      return {
        ...el,
        order_id: el.id,
        order_items: orderItemsText,
        qty: el.qty,
        total_price: total_price_text,
        refund: el.status === 'debit',
        payment_records: payment_records,
        paid_total: `HK$${this.$formatter.separator(this.$formatter.formatMoney(el.real_total - el.balance))}`,
        balance_price: `HK$${this.$formatter.separator(this.$formatter.formatMoney(el.balance))}`,
      }
    },

    allowNewPayment(order) {
      const userType = this.getUserType()
      return (
        this.$validate.allowAction('newPayment', userType) &&
        order &&
        (order.status === 'pending' || order.status === 'processing' || order.status === 'partially_paid') &&
        order.balance > 0
      )
    },
    allowApproveOrder(order) {
      const userType = this.getUserType()
      return (
        this.$validate.allowAction('approveOrder', userType) &&
        (order.status === 'pending' ||
          order.status === 'processing' ||
          (order.status === 'partially_paid' && order.balance <= 0))
      )
    },

    // -------------- Copy function
    copyText(text) {
      return new Promise(async (resolve, reject) => {
        try {
          if (typeof text === 'string') {
            await navigator.clipboard.writeText(text)
          } else {
            const clipboardItem = new ClipboardItem({
              'text/plain': text,
            })
            await navigator.clipboard.write([clipboardItem])
          }
          this.$store.dispatch('toggleSnack', {
            message: 'message.copied',
            type: 'success',
          })
          resolve(true)
        } catch (err) {
          this.$common.error(err)
          resolve(false)
        }
      })
    },
    async getCopiedText() {
      try {
        // Request permission to read from the clipboard (if not already granted)
        const permissionStatus = await navigator.permissions.query({ name: 'clipboard-read' })

        if (permissionStatus.state === 'granted' || permissionStatus.state === 'prompt') {
          const text = await navigator.clipboard.readText()
          return text
        } else {
          console.warn('Clipboard read permission denied or not supported.')
          return ''
        }
      } catch (err) {
        this.$common.error(err)
        return ''
      }
    },

    encryptData(data) {
      var encrypt = new JSEncrypt()
      encrypt.setPublicKey(this.$encryptKey)
      const encrypted = encrypt.encrypt(JSON.stringify(data))
      if (encrypted !== false) {
        return { success: true, data: encrypted }
      } else {
        return { success: false, data }
      }
    },

    // for 更表
    formatDBDataShiftCode(code) {
      switch (code) {
        case 'al':
          code = this.$t('anl')
          break
        case 'sl':
          code = this.$t('sl')
          break
        case 'holiday':
          code = this.$t('holiday')
          break
      }

      return code
    },
  },
}
</script>
